<template>
    <v-card class="py-6 px-0 trans-bkg" flat>
        <v-card-text class="pa-0">
            <draggable v-model="projectStep.tasks" @end="onTaskReorder">
                <v-list-item
                    v-for="(task, ndx) in projectStep.tasks"
                    :key="task.task_id">
                    <v-list-item-content>
                        <v-list-item-title class="d-flex">
                            <div class="d-inline mr-3 standarize_width text-right">{{ ndx + 1 }}.</div>
                            <div class="d-inline">{{ task.label }}</div>
                        </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-icon>mdi-drag</v-icon>
                    </v-list-item-action>
                </v-list-item>
            </draggable>
        </v-card-text>
        
        <v-divider class="px-1 mt-6"></v-divider>

        <v-card-actions class="justify-end">
            <v-btn
                color="primary lighten-2 info--text"
                @click="saveTaskOrder">
                Save
            </v-btn>
        </v-card-actions>
    </v-card>
</template>
  
<script>
    import axios from "axios"
    import Cookie from 'js-cookie'
    import appUrls from '../helpers/environment'
    import draggable from 'vuedraggable';
  
    export default {
        components: {
            draggable
        },

        props: {
            projectStep: {
                type: Object,
                required: true
            }
        },
        
        methods: {
            onTaskReorder(event) {
                // Handle task reorder logic if needed)
            },
        
            async saveTaskOrder () {
                try {
                    const reorder_tasks_rs = await axios.post(`${appUrls.api}/api/admin/reorder_tasks`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        projectStep_tasks: this.projectStep.tasks
                    });

                    const { data } = reorder_tasks_rs;
                    this.projectStep.tasks = data.tasks;

                    this.$emit('close');

                } catch ( error ) {
                    console.log(error);
                }
            }
        }
    }
</script>
  
<style scoped>
    .step-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .trans-bkg {
        background-color: transparent !important;
    }
    .standarize_width {
        width: 4%;
    }
</style>


// WEBPACK FOOTER //
// src/components/ProjectReportTaskReorderDialog.vue